export const widgetSchema = {
  $id: 'https://horizon.local/schema/widget.schema.json',
  id: 'https://horizon.local/schema/widget.schema.json',
  $ref: 'https://horizon.local/schema/widget.schema.json#/definitions/Widget',
  $schema: 'http://json-schema.org/draft-07/schema#',
  definitions: {
    Widget: {
      properties: {
        id: {
          type: 'string',
        },
        type: {
          type: 'string',
        },
        children: {
          type: 'array',
          items: {
            type: 'string',
          },
        },
        config: {
          type: 'object',
        },
      },
      type: 'object',
    },
  },
};
